import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../../constants/constants';
import { MINIMUM_PREPAY_THRESHOLD, PAYMENT_STEPS } from './constants';

export const componentKey = "PAYMENT_DRAWER";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setPayNowCbLoadingState: (state, action) => {
            state.payNowCbLoadingState = action.payload;
        },
        setBillingDetails: (state, action) => {
            state.billingDetails = { ...state.billingDetails, ...action.payload };
        },
        setCurrentPaymentStep: (state, action) => {
            state.currentPaymentStep = action.payload;
        },
        setEstimatedTaxCalculationComplete: (state, action) => {
            state.estimatedTaxCalculationComplete = action.payload;
        },
        setPaymentSuccessDetails: (state, action) => {
            state.paymentSuccessDetails = action.payload;
        },
        setPrepaySalesTaxAmount: (state, action) => {
            state.prepaySalesTaxAmount = action.payload;
        },
        setDisableEnterAmountField: (state, action) => {
            state.disableEnterAmountField = action.payload;
        },
        setPaymentAddressDetails: (state, action) => {
            state.paymentAddressDetails = action.payload;
        },
        setPrepayThreshold: (state, action) => {
            state.prepayThreshold = action.payload;
        }, 
        setSavedAddress: (state, action) => {
            state.savedAddress = action.payload;
        }, 
        setIsCardPayment: (state, action) => {
            state.isCardPayment = action.payload;
        }, 
        setSaveAddress: (state, action) => {
            state.saveAddress = action.payload;
        },  
        setIsUSPS: (state, action) => {
            state.isUsps = action.payload;
        },  
        setIsSubscription: (state, action) => {
            state.isSubscription = action.payload;
        },  
        setPaymentDrawerShowOnSuccessNavigationBtnsState: (state, action) => {
            state.paymentDrawerShowOnSuccessNavigationBtnsState = action.payload;
        },
        setIsPrepaidAndCardTransaction: (state, action) => {
            state.isPrepaidAndCardTransaction = action.payload;
        }, 
    },
    initialReducerState: {
        loadingState: { state: PAGE_STATE.PAGE_READY, message: "" },
        payNowCbLoadingState: { state: PAGE_STATE.PAGE_READY, message: "" },
        billingDetails: {
            EstimatedTax: 0,
            Coupon: "",
            DiscountAmount: 0,
        },
        paymentAddressDetails: {},
        currentPaymentStep: PAYMENT_STEPS.BILL_DETAILS,
        estimatedTaxCalculationComplete: false,
        paymentSuccessDetails: {
            amountPaid: 0,
        },
        savedAddress: [],
        prepaySalesTaxAmount: 0,
        disableEnterAmountField: false,
        prepayThreshold: MINIMUM_PREPAY_THRESHOLD,
        isCardPayment: false,
        saveAddress: false,
        isUsps: false,
        isSubscription: false,
        paymentDrawerShowOnSuccessNavigationBtnsState: false,
        isPrepaidAndCardTransaction: true,
    }
});

export const { 
    setLoadingState, 
    setIsSubscription, 
    setIsUSPS, 
    setSavedAddress, 
    setSaveAddress, 
    setPrepayThreshold, 
    setIsCardPayment, 
    setBillingDetails, 
    setCurrentPaymentStep, 
    setEstimatedTaxCalculationComplete, 
    setPaymentSuccessDetails, 
    setPrepaySalesTaxAmount, 
    setDisableEnterAmountField, 
    setPaymentAddressDetails,
    setPaymentDrawerShowOnSuccessNavigationBtnsState,
    setIsPrepaidAndCardTransaction,
    setPayNowCbLoadingState,
} = actions;